import { InfoCard } from "@myaccount/_components/info-card";
import { useI18n } from "@wojo/localization";
import { Button, Text } from "@wojo/ui";
import { useId } from "react";

type NoInterestedTravelersInfoCardProps = {
    openAddInterestedTravelerModal: () => void;
};

export const NoInterestedTravelersInfoCard: React.FC<
    NoInterestedTravelersInfoCardProps
> = ({ openAddInterestedTravelerModal }) => {
    const headingId = useId();
    const i18n =
        useI18n("account").account.myGroupMembers.noInterestedTravelersInfoCard;
    return (
        <section
            aria-labelledby={headingId}
            style={{
                marginBottom: "var(--g-spacing-xl)",
            }}
        >
            <InfoCard
                heading={
                    <Text.Heading
                        order="3"
                        tag="h3"
                        style={{
                            color: "currentColor",
                            paddingTop: "var(--g-spacing-md)",
                        }}
                    >
                        {i18n.textCardTitle.l()}
                    </Text.Heading>
                }
            >
                <Text.Body
                    style={{
                        color: "currentColor",
                        padding: "var(--g-spacing-sm) 0 var(--g-spacing-md) 0",
                    }}
                >
                    {i18n.textCardBody.l()}
                </Text.Body>
                <Button
                    palette="info"
                    onClick={openAddInterestedTravelerModal}
                    type="button"
                >
                    {i18n.textCardButton.l()}
                </Button>
            </InfoCard>
        </section>
    );
};
